export const PromptFieldText = {
  instructions: {
    label: 'Add instructions for your Agent',
    tooltipLabel:
      'Instructions can include AI Agent name, relevant information about the task at hand, tone of voice and other instructions',
    placeholder: 'Type answers, instructions, or notes',
  },
}
